var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogistics(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m35 6.837-7.53-4.05a.98.98 0 0 0-.94 0L1 16.527l8.01 4.31zM17.01 25.147l26-14-5.9-3.17-26 14zM45.12 12.287l-26 13.99 7.88 4.25 26-14zM10 30.367l6 3.24v-6.73l-6-3.23z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 35.277a1.012 1.012 0 0 1-.49.86 1.03 1.03 0 0 1-.51.14.966.966 0 0 1-.47-.12l-8-4.31a.984.984 0 0 1-.53-.88v-8.39l-8-4.31v27.4a.984.984 0 0 0 .53.88L26 60.267v-28l-8-4.31zM40 38a3.009 3.009 0 0 1 3-3 1.003 1.003 0 0 0 1-1 3.009 3.009 0 0 1 3-3h7V18.26l-26 14v28l14.35-7.72A21.106 21.106 0 0 1 40 42.82z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.073 38h-6.146A8.071 8.071 0 0 1 47 40.927v1.893a13.99 13.99 0 0 0 6 11.54 13.99 13.99 0 0 0 6-11.54v-1.893A8.071 8.071 0 0 1 56.073 38zm.434 6.707-3.5 3.5a1 1 0 0 1-1.414 0l-2.1-2.1a1 1 0 0 1 1.414-1.414l1.393 1.393 2.793-2.793a1 1 0 0 1 1.414 1.414z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 37a3.003 3.003 0 0 1-3-3 1 1 0 0 0-1-1H47a1 1 0 0 0-1 1 3.003 3.003 0 0 1-3 3 1 1 0 0 0-1 1v4.82a18.986 18.986 0 0 0 10.553 17.075 1.001 1.001 0 0 0 .894 0A18.986 18.986 0 0 0 64 42.82V38a1 1 0 0 0-1-1zm-2 5.82a15.982 15.982 0 0 1-7.466 13.585 1 1 0 0 1-1.068 0A15.982 15.982 0 0 1 45 42.82v-2.496a1 1 0 0 1 .57-.903 6.049 6.049 0 0 0 2.851-2.851 1 1 0 0 1 .903-.57h7.352a1 1 0 0 1 .903.57 6.049 6.049 0 0 0 2.851 2.851 1 1 0 0 1 .57.903z",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/logistics.58cb4f10edfcc62ca2189720ab83115d.svg";
export { ForwardRef as ReactComponent };